import BasePageWrap from "../layout/base-page-wrap.tsx";
import PropTypes from "prop-types";

export default function PageWrap({ children }) {
    return (
        <BasePageWrap customStyles="max-w-none w-screen md:max-h-screen md:overflow-y-auto">
            <div
                className={
                    "min-h-screen w-full bg-white bg-[url('/thumbnail_interfata.jpg')] bg-cover bg-center md:bg-[url('/thumbnail_interfata_desktop.jpg')]"
                }>
                <div className="flex min-h-screen flex-col items-center justify-center px-4 py-6">
                    <div className="w-full max-w-3xl">{children}</div>
                </div>
            </div>
        </BasePageWrap>
    );
}
PageWrap.propTypes = {
    children: PropTypes.node.isRequired,
};
